var map = {
	"./": 2812,
	"./App": 4111,
	"./App.js": 4111,
	"./assets/archive-items/adirondacks-map.png": 4358,
	"./assets/archive-items/amsterdam-moco-map.png": 6774,
	"./assets/archive-items/amsterdam-postcard.png": 7821,
	"./assets/archive-items/banff-map.png": 5528,
	"./assets/archive-items/banff-postcard-2.png": 7365,
	"./assets/archive-items/banff-postcard.png": 976,
	"./assets/archive-items/banff-ski-postcard.png": 2844,
	"./assets/archive-items/barcelona-poster.png": 9499,
	"./assets/archive-items/boston-book-2.jpg": 1860,
	"./assets/archive-items/boston-book.jpg": 2937,
	"./assets/archive-items/boston-bw-art.png": 1675,
	"./assets/archive-items/boston-color-art.png": 5125,
	"./assets/archive-items/boston-magazine-2.png": 9745,
	"./assets/archive-items/boston-magazine.png": 5140,
	"./assets/archive-items/boston-zine-2.png": 4439,
	"./assets/archive-items/boston-zine.png": 1542,
	"./assets/archive-items/chamonix-postcard.png": 7354,
	"./assets/archive-items/chamonix-vintage-poster.png": 766,
	"./assets/archive-items/ddw-pamphlet-2.png": 1456,
	"./assets/archive-items/ddw-pamphlet.png": 817,
	"./assets/archive-items/dublin-print.png": 2236,
	"./assets/archive-items/eindhoven-book.jpg": 192,
	"./assets/archive-items/eindhoven-business-card.png": 8198,
	"./assets/archive-items/eindhoven-sticker.png": 1398,
	"./assets/archive-items/excelsior-magazine-2020.png": 9616,
	"./assets/archive-items/excelsior-magazine-2022.png": 1362,
	"./assets/archive-items/excelsior-magazine-2023.png": 5019,
	"./assets/archive-items/falling-water-pamphlet.png": 2329,
	"./assets/archive-items/gaudi-house-poster.png": 1467,
	"./assets/archive-items/geneva-postcard-2.png": 1178,
	"./assets/archive-items/geneva-postcard.png": 391,
	"./assets/archive-items/glacier-postcard.png": 1120,
	"./assets/archive-items/ica-postcard.png": 6374,
	"./assets/archive-items/ica-poster.png": 4945,
	"./assets/archive-items/ie-type-print-2.png": 8742,
	"./assets/archive-items/ie-type-print.png": 395,
	"./assets/archive-items/jmt-map.png": 9954,
	"./assets/archive-items/madrid-map-2.png": 1487,
	"./assets/archive-items/madrid-map.png": 5294,
	"./assets/archive-items/madrid-museum-magazine.png": 6911,
	"./assets/archive-items/madrid-postcard.png": 3466,
	"./assets/archive-items/madrid-shared-map.png": 8468,
	"./assets/archive-items/madrid-thesis.png": 3278,
	"./assets/archive-items/madrid-transformation-map.png": 7816,
	"./assets/archive-items/madrid-type-project.png": 4030,
	"./assets/archive-items/malcolm-print.png": 3885,
	"./assets/archive-items/matterhorn-map.png": 9117,
	"./assets/archive-items/milan-book.jpg": 4047,
	"./assets/archive-items/milan-museum-ticket.png": 5299,
	"./assets/archive-items/montana-business-card-2.png": 3777,
	"./assets/archive-items/montana-business-card.png": 1140,
	"./assets/archive-items/montana-sticker.png": 1672,
	"./assets/archive-items/newspaper-poster.png": 5045,
	"./assets/archive-items/pemi-map.png": 894,
	"./assets/archive-items/philadelphia-book-2.jpg": 1978,
	"./assets/archive-items/philadelphia-book.jpg": 4683,
	"./assets/archive-items/philmont-map.png": 2536,
	"./assets/archive-items/porto-postcard-1.png": 2367,
	"./assets/archive-items/porto-postcard-2.png": 5508,
	"./assets/archive-items/porto-postcard.png": 1597,
	"./assets/archive-items/recur-sticker.png": 4087,
	"./assets/archive-items/rekin-magazine.png": 346,
	"./assets/archive-items/rekin-postcard.png": 7960,
	"./assets/archive-items/rome-hostel-bracelet.png": 5150,
	"./assets/archive-items/rome-hostel-tag.png": 920,
	"./assets/archive-items/rotterdam-museum-magazine.png": 7156,
	"./assets/archive-items/rotterdam-print.png": 3438,
	"./assets/archive-items/sala-equis.png": 9921,
	"./assets/archive-items/switzerland-business-card.png": 3643,
	"./assets/archive-items/tangier-postcard.png": 9013,
	"./assets/archive-items/tate-boat-postcard.png": 5248,
	"./assets/archive-items/tate-collage-postcard.png": 4407,
	"./assets/archive-items/tate-couple-postcard.png": 5970,
	"./assets/archive-items/tate-type-postcard.png": 1246,
	"./assets/archive-items/tolouse-print.png": 1621,
	"./assets/archive-items/tremblant-goose-print.png": 851,
	"./assets/archive-items/utrecht-photo-postcard.png": 2289,
	"./assets/archive-items/utrecht-postcard-2.png": 17,
	"./assets/archive-items/venice-business-card.png": 5870,
	"./assets/archive-items/venice-ticket.png": 1735,
	"./assets/archive-items/verbier-postcard.png": 4722,
	"./assets/archive-items/vvr-postcard.png": 2531,
	"./assets/archive-items/whitney-postcard.png": 9287,
	"./assets/archive-items/whitney-sticker.png": 6690,
	"./assets/archive-items/yosemite-postcard.png": 9830,
	"./assets/archive-items/zermatt-postcard.png": 5506,
	"./assets/year-time.svg": 893,
	"./components/dashed-circle": 1610,
	"./components/dashed-circle/": 1610,
	"./components/dashed-circle/index": 1610,
	"./components/dashed-circle/index.js": 1610,
	"./components/line": 4772,
	"./components/line/": 4772,
	"./components/line/index": 4772,
	"./components/line/index.js": 4772,
	"./components/map": 2168,
	"./components/map/": 2168,
	"./components/map/index": 2168,
	"./components/map/index.js": 2168,
	"./data": 7957,
	"./data.json": 7957,
	"./index": 2812,
	"./index.js": 2812,
	"./sections/bottom-visualization": 7968,
	"./sections/bottom-visualization/": 7968,
	"./sections/bottom-visualization/index": 7968,
	"./sections/bottom-visualization/index.js": 7968,
	"./sections/bottom-visualization/year-summary": 7829,
	"./sections/bottom-visualization/year-summary/": 7829,
	"./sections/bottom-visualization/year-summary/index": 7829,
	"./sections/bottom-visualization/year-summary/index.js": 7829,
	"./sections/legend": 5167,
	"./sections/legend/": 5167,
	"./sections/legend/index": 5167,
	"./sections/legend/index.js": 5167,
	"./sections/visualization": 1658,
	"./sections/visualization/": 1658,
	"./sections/visualization/artifactSummary": 8330,
	"./sections/visualization/artifactSummary/": 8330,
	"./sections/visualization/artifactSummary/index": 8330,
	"./sections/visualization/artifactSummary/index.js": 8330,
	"./sections/visualization/index": 1658,
	"./sections/visualization/index.js": 1658,
	"./sections/visualization/node": 2455,
	"./sections/visualization/node/": 2455,
	"./sections/visualization/node/index": 2455,
	"./sections/visualization/node/index.js": 2455,
	"./style.css": 8880,
	"./utils": 3829,
	"./utils.js": 3829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;